import React, { FC } from 'react'
import 'react-virtualized/styles.css'
import { CustomRecyclerView } from '../CustomRecyclerView'
import { GridItem } from '../GridItem'

interface GridListProps {
  data: any[]
  type: number
  onItemChecked: any
  columnCount: number
  isEdit?: boolean
  itemHeight: number
}

const GridList: FC<GridListProps> = ({ data, type, onItemChecked, columnCount, isEdit, itemHeight }: GridListProps) => {
  const renderItem = ({ item, index }: { item: any; index: any }) => {
    return (
      <GridItem
        item={item}
        type={type}
        onItemChecked={onItemChecked}
        isEdit={isEdit}
        index={index}
        dataLength={data?.length}
        itemHeight={itemHeight}
      />
    )
  }
  return (
    <CustomRecyclerView
      nativeID={'gridList'}
      data={data}
      renderItem={renderItem}
      numColumns={columnCount}
      itemHeight={itemHeight}
      extendedState={isEdit}
    />
  )
}

export { GridList }
